import "@/App.css";
import { motion } from "framer-motion";

function App() {
  return (
    <main className="orca-page" data-testid="coming-soon-page">
      {/* Logo used as the centerpiece / background */}
      <div className="orca-logo-wrap" data-testid="orca-logo-wrap">
        <motion.img
          src="/orca-logo.jpg"
          alt="ORCA Capital Partners"
          className="orca-logo"
          data-testid="orca-logo"
          initial={{ opacity: 0, scale: 1.04 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
        />
      </div>

      {/* Coming soon */}
      <motion.div
        className="orca-caption"
        data-testid="coming-soon-caption"
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.1, delay: 0.9, ease: [0.22, 1, 0.36, 1] }}
      >
        <span className="orca-line" data-testid="coming-soon-rule" />
        <h1 className="orca-title" data-testid="coming-soon-title">
          Coming Soon
        </h1>
        <span className="orca-line" data-testid="coming-soon-rule-2" />
      </motion.div>
    </main>
  );
}

export default App;
